/* eslint-disable prefer-rest-params */
import * as sensorsDefault from 'sa-sdk-javascript';
import { getQueryString } from './util';

const shenceUrl = process.env.SHENCEURL;
export const sensors = {
  init() {
    try {
      sensorsDefault.init({
        server_url: shenceUrl,
        // 如果神策代码中 `sensorsdata.min.js` 版本是 1.13.1 及以前版本，必须须配置 heatmap_url，
        // 高于此版本不需要配置。heatmap_url 神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成
        // heatmap_url: heatmap,
        // web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。
        // 如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
        // web_url:"神策分析后台地址",
        use_app_track: true, // 配置打通 App 与 H5 的参数
        is_track_single_page: true,
        heatmap: {
          // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
          // 需要 JSSDK 版本号大于 1.7
          clickmap: 'default',
          // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
          // 需要 JSSDK 版本号大于 1.9.1
          scroll_notice_map: 'default'
        }
      });
      const distinctID = getQueryString('distinctID')
      if (distinctID) {
        sensorsDefault.identify(distinctID, true)
      }
      sensorsDefault.registerPage({
        platformType: 'h5',
        open_id: distinctID || '-'
      });
      sensorsDefault.quick('autoTrackSinglePage', {
        platformType: 'h5',
        open_id: distinctID || '-'
      });
    } catch (e) {
      console.log(e)
    }
  },
  track() {
    try {
      sensorsDefault.track(...arguments)
    } catch (e) {
      console.log(e)
    }
  },
  quick() {
    try {
      sensorsDefault.quick(...arguments)
    } catch (e) {
      console.log(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/sensors.js